exports.onRouteUpdate = ({ location }) => {
  if (analytics != null) {
    analytics.page();
  }
};
